export default __webpack_public_path__ + "static/media/05.78c3e34e.png";